export default function({ dispatch, commit }, data) {
    commit('startedAuthentication')

    // POST /auth/login
    return dispatch('post', {
        url: '/auth/upgrade/verify',
        data
    }, {
        root: true
    })
    .then((result) => {
        commit('finishedAuthentication')
        if (result.set_password)
            commit('validatedUpgradeToken', result)
        return result
    })
    .catch((error) => {
        commit('finishedAuthentication')
        throw error
    })
}
